import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngxs/store';

import { GoogleTagManagerService } from '../services/analytics/google-tag-manager.service';
import { ErrorReportService } from '../services/error-report/error-report.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  typeExceptions: string[];
  messageExceptions: string[];
  store: Store;

  constructor(
    private router: Router,
    private errorReportService: ErrorReportService,
    private injector: Injector,
    private googleTagManagerService: GoogleTagManagerService
  ) {
    this.typeExceptions = ['NG0100'];
    this.messageExceptions = [
      'The popup has been closed by the user before finalizing the operation',
      'Unable to establish a connection with the popup. It may have been blocked by the browser.',
      'Timeout has occurred',
    ];
  }

  handleError(error: Error): void {
    const errorType = error.message.split(':')[0];
    const errorMessage = error.message;
    if (
      error?.name !== 'HttpErrorResponse' &&
      !this.typeExceptions.includes(errorType) &&
      !this.typeExceptions.includes(errorMessage)
    ) {
      this.reportErrorMessage(error, this.router.url);
      //console.log('error: ', error.message);
      throw error;
    }
  }

  private reportErrorMessage(error: Error, context: string): void {
    console.error(error);
    const sendError = error.stack ? error.stack : error.message;
    this.store = this.store ? this.store : this.injector.get(Store);
    if (!sendError.includes('polyfills')) {
      this.errorReportService.sendReport(
        sendError,
        context,
        this.store.snapshot()
      );
      this.googleTagManagerService.pushBookingErrorOnDataLayer({
        error_type: 'global',
        error_message: sendError,
      });
    }
  }
}
